module.exports = __webpack_public_path__ + "img/bidToBatteryFlow.2bfb6ac2.gif";